/**
 * The territory screen's route, discovered by `../routes.ts`'s glob.
 * `requires` is the same read capability as every campaign screen: the route
 * refuses a typed URL as well as hiding a link.
 */

import { createElement, type ReactNode } from 'react';
import { MapPin } from 'lucide-react';
import { useParams } from '@tanstack/react-router';

import { loadConfig } from '../../../lib/config';
import { useTerritorySelection } from '../api/territorySelection';
import type { RouteBundle } from '../../routes/contract';
import { useCampaignOrganisationId } from '../../session/orgContext';
import { tt } from './messages';
import { TERRITORY_PATH } from './paths';
import { Territory } from './Territory';

const CONTROL_PLANE_READ = 'control_plane.read';

function TerritoryRoute(): ReactNode {
  const { campaignId } = useParams({ strict: false }) as Record<string, string | undefined>;
  const tenantId = useCampaignOrganisationId();
  const selection = useTerritorySelection();
  if (tenantId === null) return null;
  return createElement(Territory, {
    campaignId: campaignId ?? '',
    tenantId,
    ...selection,
    tilesUrl: loadConfig().tilesUrl,
  });
}

export const bundle: RouteBundle = {
  routes: [
    {
      path: TERRITORY_PATH,
      element: createElement(TerritoryRoute),
      requires: CONTROL_PLANE_READ,
      kind: 'data',
    },
  ],
  nav: [],
  campaignNav: [
    {
      path: TERRITORY_PATH,
      label: () => tt('title'),
      requires: CONTROL_PLANE_READ,
      icon: MapPin,
      order: 60,
      kind: 'data',
    },
  ],
};
